import $ from 'jquery';
import uikit from '../uikit';
import * as Backbone from 'backbone';
import {getLogger} from 'loglevel';
const log = getLogger('EntryPoints');
// Corp Home
let SliderFeature = require('../components/BannerHome/BannerHome');
let BannerHomeTabList = require('../components/BannerHome/BannerHomeTabList');
let HereForTheHow = require('../components/HereForTheHow/HereForTheHow');
let LazyPicture = require('../js/LazyPicture');
let AccelerateGrowth = require('../components/AccelerateGrowth/AccelerateGrowth');
let FiveYearsOut = require('../components/FiveYearsOut/FiveYearsOut');
let AnimationScroll = require('../components/AnimationScroll/AnimationScroll');

export class CorpHomeEntryPoint extends uikit.EntryPoint {
  register() {
    log.debug('CorpHomeEntryPoint:register()');
    // Corp Home
    uikit.components.register(SliderFeature.create, {
      priority: false
    });
    uikit.components.register(BannerHomeTabList.create, {
      priority: false
    });
    uikit.components.register(HereForTheHow.create, {
      priority: false
    });
    uikit.components.register(LazyPicture.create, {
      priority: false
    });
    uikit.components.register(AccelerateGrowth.create, {
      priority: false
    });
    uikit.components.register(FiveYearsOut.create, {
      priority: false
    });
    uikit.components.register(AnimationScroll.create, {
      priority: false
    });
  }

  initialize() {
    log.debug('CorpHomeEntryPoint:initialize()');
  }
}



// WEBPACK FOOTER //
// ./assets/entryPoints/CorpHomeEntryPoint.js